/* Galeria editorial: swipe nativo en movil, crossfade con miniaturas en escritorio */
(function () {
  function init() {
    [].forEach.call(document.querySelectorAll('[data-lp-gal]'), function (g) {
      var track = g.querySelector('.lp-gal__track');
      var slides = [].slice.call(g.querySelectorAll('.lp-gal__slide'));
      var thumbs = [].slice.call(g.querySelectorAll('.lp-gal__thumb'));
      var cap = g.querySelector('.lp-gal__cap');
      var mq = window.matchMedia('(min-width: 1000px)');
      var cur = 0, raf = 0;
      function set(i) {
        cur = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (cap) cap.textContent = '0' + (i + 1) + ' / 0' + slides.length + ' \u00b7 ' + slides[i].getAttribute('data-label');
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          set(i);
          if (!mq.matches) track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!n) return;
          var j = (i + n + thumbs.length) % thumbs.length; thumbs[j].focus(); thumbs[j].click(); e.preventDefault();
        });
      });
      track.addEventListener('scroll', function () {
        if (mq.matches) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var x = track.scrollLeft + slides[0].offsetLeft, best = 0, d = 1e9;
          slides.forEach(function (s, k) { var dd = Math.abs(s.offsetLeft - x); if (dd < d) { d = dd; best = k; } });
          if (best !== cur) set(best);
        });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
